(()=>{
  const body=document.body;
  if(!body||body.dataset.dvMotionEnabled!=='true')return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const active=new Set();
  const seen=new WeakSet();
  const duration=Number(body.dataset.dvDuration)||650;
  const expressive=body.dataset.dvMotionStyle==='expressive';
  const distance=expressive?30:18;
  const allowed=element=>!element.closest('[data-dv-section-motion="none"]');
  const run=(element,frames,options={})=>{
    if(reduced.matches||!element.animate||!allowed(element))return;
    const animation=element.animate(frames,{duration,easing:'cubic-bezier(.2,.8,.2,1)',...options});
    active.add(animation);
    const release=()=>active.delete(animation);
    animation.addEventListener('finish',release,{once:true});
    animation.addEventListener('cancel',release,{once:true});
  };
  const entrance=(element,delay=0)=>run(element,[{opacity:.12,transform:`translateY(${distance}px)`},{opacity:1,transform:'translateY(0)'}],{delay,fill:'backwards'});
  let revealObserver;
  const revealSelectors='main h1,main h2,main .dv-eyebrow,main .dv-rich,main .dv-buttons,main .dv-system-card,main .dv-treatment,main .dv-product-grid article,main .dv-system-individuals article,main .dv-system-steps article,main .dv-system-detail-list article,main .dv-values>div,main .dv-faq-list details,main .dv-system-inclusion,main .dv-lp-card,main .dv-lp-review';
  const cards='.dv-lp-card,.dv-lp-review,.dv-system-card,.dv-treatment,.dv-product-grid article,.dv-system-individuals article,.dv-system-steps article,.dv-system-detail-list article,.dv-values>div,.dv-faq-list details';
  const startReveals=root=>{
    if((body.dataset.dvReveal!=='true'&&body.dataset.dvEntrance!=='true')||reduced.matches||!('IntersectionObserver'in window))return;
    revealObserver??=new IntersectionObserver(entries=>{
      const entering=entries.filter(entry=>entry.isIntersecting);
      entering.forEach((entry,index)=>{
        revealObserver.unobserve(entry.target);
        entrance(entry.target,Math.min(index,3)*65);
      });
    },{threshold:.12,rootMargin:'0px 0px -24px 0px'});
    root.querySelectorAll(revealSelectors).forEach(element=>{
      if(seen.has(element)||!allowed(element))return;
      const parentCard=element.parentElement.closest(cards);
      if(parentCard)return;
      seen.add(element);
      const rect=element.getBoundingClientRect();
      if(!rect.height||!rect.width)return;
      if(rect.top<innerHeight&&rect.bottom>0){
        if(body.dataset.dvEntrance==='true'&&!window.Shopify?.designMode&&element.matches('h1,.dv-hero-copy>.dv-eyebrow,.dv-hero-copy>.dv-rich,.dv-hero-copy>.dv-buttons')){
          run(element,[{opacity:.72,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:Math.min(duration,600)});
        }
      }else if(rect.top>=innerHeight&&body.dataset.dvReveal==='true'){revealObserver.observe(element);}
    });
  };
  const tickerObserver='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.toggleAttribute('data-dv-offscreen',!entry.isIntersecting)),{rootMargin:'60px'}):null;
  const setup=root=>{
    if(body.dataset.dvHover==='true')root.querySelectorAll('.dv-lp-card-image img,.dv-system-image,.dv-treatment img,.dv-product-grid img,.dv-system-individuals img,.dv-split-media,.dv-system-detail-image img').forEach(image=>{if(allowed(image))image.classList.add('dv-motion-image');});
    if(body.dataset.dvParallax==='true')root.querySelectorAll('.dv-hero .dv-bg,.dv-invitation .dv-bg,.dv-background-section .dv-bg').forEach(image=>{if(allowed(image))image.classList.add('dv-motion-parallax');});
    root.querySelectorAll('[data-dv-ticker]').forEach(ticker=>tickerObserver?.observe(ticker));
    startReveals(root);
  };
  document.addEventListener('click',event=>{
    const thumbnail=event.target.closest('[data-dv-thumb]');
    if(thumbnail&&body.dataset.dvDetails==='true'&&allowed(thumbnail)){
      queueMicrotask(()=>{
        const image=thumbnail.closest('[data-dv-gallery]').querySelector('[data-dv-main]');
        const expected=image.getAttribute('src');
        const ready=image.decode?image.decode():Promise.resolve();
        ready.then(()=>{if(image.getAttribute('src')===expected)run(image,[{opacity:.5,scale:'.99'},{opacity:1,scale:'1'}],{duration:260});}).catch(()=>{});
      });
    }
  });
  document.addEventListener('toggle',event=>{
    const details=event.target;
    if(body.dataset.dvDetails!=='true'||!details.matches?.('.dv-mobile-menu[open]'))return;
    const nav=details.querySelector('nav');
    run(nav,[{opacity:0,transform:'translateY(-8px)'},{opacity:1,transform:'translateY(0)'}],{duration:260});
  },true);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll(revealSelectors).forEach(element=>revealObserver?.unobserve(element));
    event.target.querySelectorAll('[data-dv-ticker]').forEach(element=>tickerObserver?.unobserve(element));
    active.forEach(animation=>{if(event.target.contains(animation.effect?.target))animation.cancel();});
  });
  document.addEventListener('shopify:section:select',()=>active.forEach(animation=>animation.finish()));
  document.addEventListener('shopify:block:select',()=>active.forEach(animation=>animation.finish()));
  document.addEventListener('visibilitychange',()=>{
    body.classList.toggle('dv-motion-tab-hidden',document.hidden);
    if(document.hidden)active.forEach(animation=>animation.finish());
  });
  reduced.addEventListener('change',()=>{
    revealObserver?.disconnect();
    active.forEach(animation=>animation.cancel());
    if(!reduced.matches)setup(document);
  });
  setup(document);
})();
